import { useEffect } from 'react';

interface HotjarScriptProps {
  hjid: number;
  hjsv: number;
}

const HotjarScript = ({ hjid, hjsv }: HotjarScriptProps) => {
  useEffect(() => {
    // Only run in production environments
    if (import.meta.env.PROD) {
      const hotjarScript = document.createElement('script');
      hotjarScript.innerHTML = `
        (function(h,o,t,j,a,r){
            h.hj=h.hj||function(){(h.hj.q=h.hj.q||[]).push(arguments)};
            h._hjSettings={hjid:${hjid},hjsv:${hjsv}};
            a=o.getElementsByTagName('head')[0];
            r=o.createElement('script');r.async=1;
            r.src=t+h._hjSettings.hjid+j+h._hjSettings.hjsv;
            a.appendChild(r);
        })(window,document,'https://static.hotjar.com/c/hotjar-','.js?sv=');
      `;
      document.head.appendChild(hotjarScript);

      // Cleanup function to remove the script when component unmounts
      return () => {
        if (hotjarScript.parentNode) {
          hotjarScript.parentNode.removeChild(hotjarScript);
        }
      };
    }
  }, [hjid, hjsv]);

  return null;
};

export default HotjarScript;